import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const ACTIVE_PLANS = ["trialing", "trial", "essentiel", "pro", "premium"];

export default function ProtectedRoute({ children, requireOnboarded = true, requirePlan = true }) {
  const { user, loading, login } = useAuth();

  useEffect(() => {
    if (!loading && !user) login();
  }, [loading, user, login]);

  if (loading || !user) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="w-10 h-10 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-muted-foreground font-mono text-sm">Connexion à votre espace…</p>
        </div>
      </div>
    );
  }
  if (requireOnboarded && !user.onboarded) return <Navigate to="/onboarding" replace />;
  if (requirePlan && !ACTIVE_PLANS.includes(user.plan)) return <Navigate to="/abonnement" replace />;
  return children;
}
